// extracted by mini-css-extract-plugin
module.exports =  {"ListItemBordered":"D2w7Ap6FfZp2wDXxjNRa"};